'use client';

import { useSupporterQuery } from '@sola/supporter-sdk/hooks/base.ts';
import { volunteerEventsQuery } from '@sola/supporter-sdk/queries.ts';

export const VolunteerEvents = () => {
  const { data, isLoading, isError } = useSupporterQuery(volunteerEventsQuery);
  const volunteerEvents = data ?? [];

  if (isLoading) {
    return <div>Loading volunteer events...</div>;
  }

  if (isError) {
    return <div>Unable to load volunteer events.</div>;
  }

  if (!volunteerEvents.length) {
    return <div>No volunteer events found.</div>;
  }

  return (
    <div>
      {volunteerEvents.map((event) => {
        const { slots, ...eventData } = event;

        return (
          <section key={event.id}>
            <h2>Volunteer event</h2>
            <pre>{JSON.stringify(eventData, null, 2)}</pre>

            <h3>Slots</h3>
            {slots.map((slot) => (
              <pre key={slot.id}>{JSON.stringify(slot, null, 2)}</pre>
            ))}
          </section>
        );
      })}
    </div>
  );
};
